import { Component, effect, input } from '@angular/core';
import { UIChart } from 'primeng/chart';
import { ChartDto } from '../../../../api';

@Component({
  selector: 'app-chart-stacked-bar',
  imports: [UIChart],
  templateUrl: './chart-stacked-bar.component.html',
  styleUrl: './chart-stacked-bar.component.css',
})
export class ChartStackedBarComponent {
  chartData = input.required<ChartDto>();

  data: any;
  options: any;

  constructor() {
    effect(() => {
      const dto = this.chartData();
      this.buildChart(dto);
    });
  }

  buildChart(dto: ChartDto) {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--p-text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
    const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

    this.data = {
      labels: dto!.labels!.map((label) => {
        const date = new Date(label);
        const weekday = date.toLocaleDateString('pl-PL', { weekday: 'short' });
        const dayMonth = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}`;
        return `${weekday} ${dayMonth}`;
      }),
      datasets: dto!.datasets!.map((dataset) => ({
        type: 'bar',
        label: dataset.label,
        clientName: dataset.clientName,
        backgroundColor: dataset.backgroundColor,
        data: dataset.data!.map((d) => (d ?? 0) / 60),
        borderRadius: 6,
        barPercentage: 0.6,
      })),
    };

    this.options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        tooltip: {
          callbacks: {
            label: (ctx: any) => {
              if (!ctx.parsed.y) return '';

              const h = Math.floor(ctx.parsed.y);
              const m = Math.round((ctx.parsed.y - h) * 60);

              return [
                `${ctx.dataset.label}`,
                `Klient: ${ctx.dataset.clientName ?? '-'}`,
                `Czas: ${h}:${m.toString().padStart(2, '0')} h`,
                ``,
              ];
            },
          },
          filter: (tooltipItem: any) => tooltipItem.parsed.y !== 0,
          mode: 'index',
          intersect: false,
        },
        legend: {
          labels: {
            color: textColor,
          },
        },
        datalabels: {
          display: false,
          anchor: 'end',
          align: 'top',
          formatter: (value: number) => {
            if (!value || value === 0) {
              return '';
            }

            const h = Math.floor(value);
            const m = Math.round((value - h) * 60);

            return `${h}:${m.toString().padStart(2, '0')}`;
          },
          color: '#6b7280',
          font: {
            weight: 'bold',
            size: 12,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
            display: false,
          },
        },
        y: {
          beginAtZero: true,
          grace: '20%',
          stacked: true,
          ticks: {
            stepSize: 1,
            callback: (value: number) => `${value}h`,
            color: textColorSecondary,
          },
          title: {
            display: true,
            text: 'Godziny',
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };
  }
}
